unit uSettings;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls;

type
  TfrmSettings = class(TForm)
    memoChangelog: TMemo;
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
  protected procedure LoadDFMValues; override; end;

var
  frmSettings: TfrmSettings;

implementation

{$R *.dfm}

procedure TfrmSettings.LoadDFMValues;
begin
  inherited LoadDFMValues;

  memoChangelog := TMemo.Create(Self);

  memoChangelog.BeforeLoadDFMValues;
  try
    Name := 'frmSettings';
    Width := 640;
    Height := 480;
    memoChangelog.SetParentComponent(Self);
    memoChangelog.Name := 'memoChangelog';
    memoChangelog.Left := 0;
    memoChangelog.Top := 0;
    memoChangelog.Width := 640;
    memoChangelog.Height := 480;
    memoChangelog.Align := alClient;
    memoChangelog.HeightPercent := 100.000000000000000000;
    memoChangelog.Lines.BeginUpdate;
    try
      memoChangelog.Lines.Clear;
      memoChangelog.Lines.Add('Keine Einstellungen aber ... eine');
      memoChangelog.Lines.Add('Versions'#252'bersicht');
      memoChangelog.Lines.Add('');
      memoChangelog.Lines.Add('Grunds'#228'tzliche Info vorab');
      memoChangelog.Lines.Add('');
      memoChangelog.Lines.Add('- Punktevergabe: Volltreffer (Position richtig) = 3 Punkte, Fahrer innerhalb der Top 5 = 1 Punkt');
      memoChangelog.Lines.Add('- Aktualisierung der Rennergebnisse: diese werden von einem externen System 2 - 6 Stunden nach GP-Ende zur Verf'#252'gung gestellt. Im Laufe der Saison suche ich nach einer schnelleren Methode.');
      memoChangelog.Lines.Add('- Es ist immer noch eine Beta-Version, d. h. Abst'#252'rze oder seltsames Verhalten k'#246'nnen durchaus noch vorkommen ;-)');
      memoChangelog.Lines.Add('- W'#252'nsche, Anregungen und Bugs gerne an mich per WhatsApp ');
      memoChangelog.Lines.Add('');
      memoChangelog.Lines.Add('17.05.2025 - Imola-Release');
      memoChangelog.Lines.Add('----------------------------');
      memoChangelog.Lines.Add('- die Fahrerwahl wird jetzt in einer neuen Tabelle angezeigt. Hinzugekommen ist das Feld Pos., welches die Startposition des Fahrers entspricht. Sortiert werden kann nach Pos. und Nachname indem man auf den entsprechenden Pfeil in der Titelleiste klickt.');
      memoChangelog.Lines.Add('');
      memoChangelog.Lines.Add('');
      memoChangelog.Lines.Add('19.04.2025 - Saudi - Release');
      memoChangelog.Lines.Add('-----------------------------------');
      memoChangelog.Lines.Add('- nichts sichtbares ge'#228'ndert, aber einiges im Hintergrund was Datenbankanbindung und Auswertung angeht');
      memoChangelog.Lines.Add('');
      memoChangelog.Lines.Add('05.04.2025 - Suzuka - Release');
      memoChangelog.Lines.Add('-------------------------------------');
      memoChangelog.Lines.Add('- Es k'#246'nnen keine Fahrer mehr doppelt innerhalb eines Tipps gew'#228'hlt werden');
      memoChangelog.Lines.Add('- Unter "Standings" sieht man jetzt ein Chart mit den Punktest'#228'nden aller User, darunter jeweils pro GP ein Infoblock. Hier ist das Rennergebnis ersichtlich, gegen'#252'bergestellt die Tipps der User mit Punktevergabe');
      memoChangelog.Lines.Add('- (BUG) Unter Firefox funktionieren die Rundungen der Infobl'#246'cke nicht');
      memoChangelog.Lines.Add('- (BUG) Manchmal klappts mit den Schriften noch nicht so ganz (Schriftart, Positionen)');
      memoChangelog.Lines.Add('');
      memoChangelog.Lines.Add('21.03.2025 - Erste Beta-Version');
      memoChangelog.Lines.Add('---------------------------------------');
      memoChangelog.Lines.Add('- Grunds'#228'tzliches Design steht');
      memoChangelog.Lines.Add('- Registrierung und Login / Logout funktionieren');
      memoChangelog.Lines.Add('- Unter "Aktuell" k'#246'nnen Tipps zum n'#228'chsten Rennen (Sprint) abgegeben werden');
      memoChangelog.Lines.Add('- Keine Statistik, Daten werden aber in Datenbank erfasst und werden sp'#228'ter ausgewertet');
      memoChangelog.Lines.Add('');
    finally
      memoChangelog.Lines.EndUpdate;
    end;
    memoChangelog.SelLength := 0;
    memoChangelog.SelStart := 1888;
    memoChangelog.WidthPercent := 100.000000000000000000;
  finally
    memoChangelog.AfterLoadDFMValues;
  end;
end;

end.